module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "author-blurb ParaOverride-1"
  }, [_vm._v("A. M. Houston trained as a nurse and midwife and then focused on public health by training as a health visitor. She worked in the National Health Service in the UK for many years. She became interested in health research and left frontline practice to concentrate on research into community and family health. A. M. Houston completed her PhD at King’s College London.")]), _vm._v(" "), _c('p', {
    staticClass: "author-blurb"
  }, [_vm._v("Dr. A. M. Houston returned to front-line community service and developed a special interest in child development and child protection issues. She enjoyed developing practice, supporting students and most of all helping families with their pre-school children. Throughout her early years’ practice, A. M. Houston passionately believed in the importance of reading to pre-school children as a valuable initial part of a child’s progress into education.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/cover.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "copyright-heading ParaOverride-1"
  }, [_vm._v("Copyright © A. M. Houston 2024")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A. M. Houston ")]), _vm._v("to be identified as author and illustrator of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body"
  }, [_vm._v("ISBN 9781035829835 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("ISBN 9781035829842 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-1"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-body ParaOverride-2"
  }, [_vm._v("First Published 2024"), _c('br'), _vm._v("Austin Macauley Publishers Ltd"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("®")]), _c('br'), _vm._v("1 Canada Square "), _c('br'), _vm._v("Canary Wharf "), _c('br'), _vm._v("London"), _c('br'), _vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "ded-1 ParaOverride-1"
  }, [_vm._v("Well done to mums and dads, grans and grandpas, aunties and uncles and all of our child carers for their dedication in reading, pointing and showing.")]), _vm._v(" "), _c('p', {
    staticClass: "ded ParaOverride-1"
  }, [_vm._v("This book is dedicated to all of those carers who put away their phone and switch off the TV and spend quiet time, sitting patiently, reading to children. These golden times show that in the beginning the children are simply learning to point and trying to turn the pages. How quickly they can learn to join in with the story and soon it is the carer turning the pages as little voices, confidently, take over the story.")]), _vm._v(" "), _c('p', {
    staticClass: "ded ParaOverride-3"
  }, [_vm._v("In writing this book, I have tried to make it fun for parents and children to keep on returning to read and turn all those same pages. Telling and retelling the story, listening and engaging, all of these little voices, again and again. This is a skill that carers have in abundance. Of course, it is all about Rags’ doggy adventures and that allows little children to learn, to look, to count and to enjoy their reading journey with Rags in the Bluebell Wood.")]), _vm._v(" "), _c('p', {
    staticClass: "ded ParaOverride-1"
  }, [_vm._v("I would like to thank the team at Austin Macauley Publishers for their incredible patience in working so hard to understand my vision of what a real little dog called Rags might find adventurous, in a place that I have called the Bluebell Wood.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("I hoped to create an appealing woodland world for little children to engage with. This is a kind, gentle, world of Bluebell Wood doggy friends, woodland animals and things that a dog like Rags, likes to find. It was always my aim that I might engage children’s interest in Rags adventures. Encouraging these very young listeners and beginning readers on their own reading journey is my own lovely reward.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Rags liked to walk in the Bluebell Wood.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("One day Rags met a horse and the lady riding on the horse said, ‘Good morning, Rags.’ ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Woof!’ said Rags with a waggy tail. The guardian and Rags quietly watched the horse as it clip-clopped home.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Just then Rags heard a sound in the Bluebell Wood.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Tap, tap. Tap, tap, tap. Tap, tap, tap, tap.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Rags saw two woodpeckers with their tiny red hats.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("They were up in the tree making a great noise as they tapped on the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Tap. Tap. Tap.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Can you find the Woodpeckers in the tree?")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Counting_with_Rags_-_02_v3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Next on the path Rags met three beautiful blue butterflies as they fluttered past.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Rags jumped and jumped but he couldn’t reach the blue butterflies.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Bye, bye, 1…2…3… beautiful butterflies and Rags walked on in the Bluebell Wood.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_03.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Rustle, rustle. Something moved in the bushes. Rags stopped to look and he saw:")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("four bunny rabbits. The rabbits did a little snuffle, then mummy rabbit did a hippity hop. The baby rabbits did a hippity hop and soon they were all gone, hippity hopping home.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Can you find the Bunny Rabbits? 1… 2… 3… 4…")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-6",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_04.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Sniff, Sniff, Rags stopped to smell the flowers and there he found:")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Five busy bees.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Buzz, buzz,’ said the 1st busy bee.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Buzz, buzz,’ said the 2nd busy bee.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Buzz, buzz,’ said the 3rd busy bee.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Buzz, buzz,’ said the 4th busy bee.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘I’m buzzing off to make honey,’ said the 5th busy bee as it flew home to the bee hive.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Can you count the busy bees? 1…2…3…4…5…")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_05.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Rags and his guardian walked past the field, ‘Shh! Shh! Shh!’ Said the guardian.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("There in the field they saw six deer: "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("can you count the deer 1…2…3…4…5…6")])]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("They were standing still, watching Rags. ‘Woof! Woof!’ said Rags, and suddenly all the deer ran fast and jumped into the deep woods to hide.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-8",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Counting_with_Rags_-_06_v3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Rags walked on in the Bluebell Wood and soon he reached the bench.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("There were always squirrels at the bench eating seeds and nuts.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Can you count the squirrels at the bench? 1…2…3…4…5…6…7")])]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Well done! There were seven squirrels at the bench and suddenly they were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Naughty Rags chased them all away and they scampered up into the trees. ")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Woof! Woof! Woof! Woof! Woof!’ said Rags.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Walk on, Rags,’ said the guardian. Rags walked on nicely.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_07.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Soon Rags came to the hill on the side of the path.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("He could hear the, ‘Cook-cook, cook-cook,’ of the pheasants as they called out.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Rags called back, ‘Woof! Woof!’")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("And then,")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Eight pheasant birds 1…2…3…4…5…6…7…8")]), _vm._v(" very busy birds ran out of the bush. They were running fast and they went everywhere. They made a big noise and went into the trees, out of the field, across the path, behind the hedge, in front of the trees and over the fence into the field.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("‘Oh! Dear me!’ said the Guardian. ‘Run home pheasants quickly.’ The pheasants all ran home very fast. Bye, bye, pheasants.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-7",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_08.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("‘Woof! Woof!’ said Rags as he walked on in the Bluebell Wood. Rags looked into the next field. He could see the sheep quietly grazing. Rags looked at the sheep and the sheep looked at Rags. ‘Good boy, Rags,’ said the guardian and Rags walked on quietly past the sheep. "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Can you count the sheep?")])]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("1…2…3…4…5…6…7…8…9… sheep in the field.")])]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Well done! Good counting!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-10",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_09.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v("Rags walked along happily until he met his doggy friends in the big field at the end of the path. Rags friends were: big dogs, little dogs, fat dogs, thin dogs, fluffy dogs, smooth dogs, quiet dogs, noisy dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("Rags was pleased to see his doggy friends. They were running, jumping, rolling, chewing, playing and barking. ‘Woof! Woof!’ said Rags.")]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Can you count all of Rags’ doggy friends in the field?")])]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("1…2…3…4…5…6…7…8…9… and Rags makes 10.")])]), _vm._v(" "), _c('p', {
    staticClass: "book-text"
  }, [_vm._v("10 dogs in the field. Well done! Good counting!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-11",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Counting_with_Rags_-_10_V5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1 ParaOverride-1"
  }, [_vm._v("Today on his walk Rags saw:")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("1.\tHorse: trotting")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("2.\tWoodpeckers: tapping")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("3.\tBlue Butterflies: fluttering")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("4.\tBunny Rabbits: hopping")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("5.\tBusy Bees: buzzing")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("6.\tDeer: jumping")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("7.\tSquirrels: scampering")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("8.\tPheasants: running")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("9.\tSheep: grazing")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("10.\tDogs: playing")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-9",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Counting_with_Rags_-_11_v3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('p', {
    staticClass: "book-text-line-1"
  }, [_vm._v(" ‘What an exciting walk in the Bluebell Wood,’ said the guardian. ‘Let’s go home for tea. What a good boy, Rags! Good walking – most of the time.’")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-5",
    attrs: {
      "alt": "",
      "src": "image/72701_-_Illustration_-_V2_-_12.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-12",
    attrs: {
      "alt": "",
      "src": "image/Rags1_(1).jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("THE END")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b521f634","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled1.vue
// module id = 57
// module chunks = 0